export const facturationComplete = 'COMPLETE';
export const facturationSimplifiee = 'SIMPLIFIEE';
export const facturationAgregee = 'AGREGEE';
export const facturationCompleteLibelle = 'Complète';
export const facturationSimplifieeLibelle = 'Simplifiée';
export const facturationAgregeeLibelle = 'Agrégée';

export const facturationCompleteDescription =
    'Facture contenant une ligne par article. (Libellés affichés)';
export const facturationSimplifieeDescription =
    'Facture contenant une ligne par taux de TVA. (Libellés non affichés)';
export const facturationAgregeeDescription =
    'Facture contenant une ligne par rubrique de facturation et taux de TVA. (Libellés non affichés)';

export type facturationType =
    | typeof facturationComplete
    | typeof facturationSimplifiee
    | typeof facturationAgregee;

export const paddingFacturationTab = '32px';
export const heightFooterFacturation = '140px';
